const index = () => import(/* webpackChunkName: "group" */ './pages/index/index.vue')
const center = () => import(/* webpackChunkName: "group" */ './pages/personalCenter/index.vue')
const createOrder = () => import(/* webpackChunkName: "group-order" */ './pages/order/createOrder/index.vue')
const orderDetail = () => import(/* webpackChunkName: "group-order" */ './pages/order/orderDetail/index.vue')
const orderList = () => import(/* webpackChunkName: "group-order" */ './pages/order/orderList/index.vue')
const orderReplace = () => import(/* webpackChunkName: "group-order" */ './pages/order/orderReplace/index.vue')
const paySuccess = () => import(/* webpackChunkName: "group-order" */ './pages/order/paySuccess/index.vue')
const addressList = () => import(/* webpackChunkName: "group-order" */ './pages/address/addressList.vue')
const addressAdd = () => import(/* webpackChunkName: "group-order" */ './pages/address/addressAdd.vue')
const invoice = () => import(/* webpackChunkName: "group-invoice" */ './pages/invoiceData/index.vue')
const groupIndex = () => import(/* webpackChunkName: "group-index" */ './pages/groupIndex/index.vue')
const quoteDetail = () => import(/* webpackChunkName: "group-quote" */ './pages/quoteDetail/index.vue')

export const GROUP_ROUTE_PREFIX = '/group'

export default [
  {
    path: GROUP_ROUTE_PREFIX,
    name: 'groupIndexHome',
    component: index,
    meta: {
      title: '袋鼠团'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/groupIndex`,
    name: 'groupGroupIndex',
    component: groupIndex,
    meta: {
      title: '袋鼠团'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/index`,
    redirect: GROUP_ROUTE_PREFIX
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/center`,
    name: 'groupCenter',
    component: center,
    meta: {
      title: '个人中心'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/createOrder`,
    name: 'groupCreateOrder',
    component: createOrder,
    meta: {
      title: '创建订单'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/orderDetail`,
    name: 'groupOrderDetail',
    component: orderDetail,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/orderList`,
    name: 'groupOrderList',
    component: orderList,
    meta: {
      title: '订单列表'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/orderReplace`,
    name: 'groupOrderReplace',
    component: orderReplace,
    meta: {
      title: '好友代付'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/paySuccess`,
    name: 'groupPaySuccess',
    component: paySuccess,
    meta: {
      title: '支付成功'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/addressList`,
    name: 'groupAddressList',
    component: addressList,
    meta: {
      title: '收货地址'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/addressAdd`,
    name: 'groupAddressAdd',
    component: addressAdd,
    meta: {
      title: '收货地址'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/invoice`,
    name: 'groupInvoice',
    component: invoice,
    meta: {
      title: '发票资料'
    }
  },
  {
    path: `${GROUP_ROUTE_PREFIX}/quoteDetail`,
    name: 'groupQuoteDetail',
    component: quoteDetail,
    meta: {
      title: '报价详情'
    }
  }
]



// WEBPACK FOOTER //
// ./src/group/routes.js